import React, { forwardRef, useState } from 'react';
import { Icon } from 'ensightful-koala-ui';
import styled from 'styled-components';

const DropDownInputContainer = styled.div`
    width: 100%;
    position: relative;
`;

const DropDownInput = styled.input`
    width: 100%;
    height: 40px;
    border: 1px solid rgba(0, 0, 0, 0.24);
    border-radius: 6px;
    font-size: 14px;
    padding-left: 15px;
    padding-right: 35px;
    cursor: ${(props) => (props.typable ? 'initial' : 'pointer')};

    &:focus {
        outline: none;
        border: 1px solid #4136c0;
        color: #6347ff;
    }

    &:hover {
        outline: none;
        border: 1px solid #4136c0;
    }

    &:disabled {
        background-color: white;
        border-color: rgba(0, 0, 0, 0.24);
        cursor: not-allowed;
    }
`;

const StyledIcon = styled(Icon)`
    position: absolute;
    top: 50%;
    right: 0;
    transform: translate(-16px, -50%);
    cursor: pointer;

    & path {
        fill: #757575;
        transform: none;
    }
`;

const DropDownInputWrapper = forwardRef(
    ({ disabled, value, handleChangeText, clickListener, dropDownOpen, typable, onKeyPress, ...props }, ref) => {
        const handleChange = (e) => {
            handleChangeText(e.target.value);
        };

        return (
            <DropDownInputContainer onClick={clickListener} {...props}>
                <DropDownInput
                    ref={ref}
                    autoComplete={'off'}
                    disabled={disabled}
                    value={value}
                    onChange={handleChange}
                    typable={typable}
                    onKeyPress={onKeyPress}
                />
                <StyledIcon kind={dropDownOpen ? 'drop-up-arrow' : 'drop-down-arrow'} size={10} />
            </DropDownInputContainer>
        );
    }
);

export default DropDownInputWrapper;
